export default __webpack_public_path__ + "static/tractor2-204a25efe466ab7f44b39ece584e04a1.jpg";